import axios from 'axios';
import { FETCH_USER, FETCH_SURVEYS } from './types';

// export const fetchUser = () => {
//     return function(dispatch) {
//         axios.get('/api/current_user') // in prod this goes dirrectly to express backend, there is no create react app etc
//             .then(res => dispatch({type: FETCH_USER, payload: res}));
//     }
// };
// refactor code above

// export const fetchUser = () => dispatch => {
//     axios
//         .get('/api/current_user') // in prod this goes dirrectly to express backend, there is no create react app etc
//         .then(res => dispatch({type: FETCH_USER, payload: res})); // refactor for async syntax, add async to 2nd parameter to dispatch
        
// };

// refactor futher for async syntax !
export const fetchUser = () => async dispatch => {
    const res = await axios.get('/api/current_user');

    dispatch({type: FETCH_USER, payload: res.data});    
};

// refactor futher, lol, no need tough
// export const fetchUser = () => async dispatch => 
//     dispatch({type: FETCH_USER, payload: await axios.get('/api/current_user')});


// payments
export const handleToken = (token) => async dispatch => {
    const res = await axios.post('/api/stripe', token);
    // backend will return the same fetch user so the same type
    dispatch({type: FETCH_USER,payload: res.data});
};

// surveys
export const submitSurvey = (values, history) => async dispatch => {
    const res = await axios.post('/api/surveys', values)

    // after request is completed call withRouter history from component
    history.push('/surveys');
    
    dispatch({type: FETCH_USER, payload: res.data});
}

// fetch surveys
export const fetchSurveys = () => async dispatch => {
    const res = await axios.get('/api/surveys');

    dispatch({ type: FETCH_SURVEYS, payload: res.data});
};


